import SubscribeActionTypes from './types';

const initialState = {
  hasSubscribed: false,
  isSaving: false,
  isFetching: false,
  razorPG: {},
  wallet: { balanceInPaisa: 0, active: true },
};

const subscribeReducer = (state: any = initialState, action: { type: string; payload: any }) => {
  switch (action.type) {
    case SubscribeActionTypes.SUBSCRIBE_START:
      return {
        ...state,
        hasSubscribed: false,
        isSaving: true,
        wallet: {
          active: true,
          balanceInPaisa: 0,
        },
      };

    case SubscribeActionTypes.SUBSCRIBE_SUCCESS:
      return {
        ...state,
        hasSubscribed: true,
        isSaving: false,
      };

    case SubscribeActionTypes.SUBSCRIBE_FAILURE:
      return {
        ...state,
        hasSubscribed: false,
        isSaving: false,
      };
    case SubscribeActionTypes.GET_BALANCE:
      return {
        ...state,
        isFetching: true,
      };
    case SubscribeActionTypes.GET_BALANCE_SUCCESS:
      return {
        ...state,
        wallet: action.payload,
        isFetching: false,
      };
    case SubscribeActionTypes.GET_BALANCE_FAILURE:
      return {
        ...state,
        isFetching: false,
      };
    case SubscribeActionTypes.INITIATE_RAZORPAY_PAYMENT:
      return {
        ...state,
        isFetching: true,
      };
    case SubscribeActionTypes.INITIATE_RAZORPAY_PAYMENT_SUCCESS:
      return {
        ...state,
        isFetching: false,
        razorPG: action.payload,
      };
    case SubscribeActionTypes.INITIATE_RAZORPAY_PAYMENT_FAILURE:
      return {
        ...state,
        isFetching: false,
      };
    case SubscribeActionTypes.COMPLETE_RAZORPAY_PAYMENT:
      return {
        ...state,
        isFetching: true,
      };

    case SubscribeActionTypes.COMPLETE_RAZORPAY_PAYMENT_SUCCESS:
      return {
        ...state,
        isFetching: false,
      };

    case SubscribeActionTypes.COMPLETE_RAZORPAY_PAYMENT_FAILURE:
      return {
        ...state,
        isFetching: false,
      };

    default:
      return state;
  }
};

export default subscribeReducer;
// const test = {
//   transactionId: 'WEWLTTXN1006663755198968',
//   pg: 'RAZORPAY',
//   pgKey: 'rzp_test_nS5XCuM6G80wwW',
//   pgOrderId: 'order_KU3HxG2teZF90c',
//   amountInPaisa: 50000,
// };
